import {getBaseFetchHeaders} from '@github-ui/fetch-headers'

export async function fetchJson<T>(url: string): Promise<T | null> {
  try {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...getBaseFetchHeaders(),
      },
    })
    if (response.ok) {
      return await response.json()
    }
  } catch {
    // Network failure
  }
  return null
}
